import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { APIResponse } from '../interfaces/api.interface';
import { Job } from '../interfaces/job.interface';
import { Template, TemplateCreate, TemplateSearchParams, TemplateUpdate } from '../interfaces/template.interface';
import { queryParamString } from '../utils/query-param-string';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class TemplateService {
  public constructor(private readonly api: ApiService) {}

  public get(organisationId: string, templateId: string): Observable<Template> {
    return this.api.get<Template>(
      `organisations/${organisationId}/templates/${encodeURIComponent(templateId)}`,
    );
  }

  public create(organisationId: string, data: TemplateCreate): Observable<Template> {
    return this.api.post<Template, TemplateCreate>(
      `organisations/${organisationId}/templates`,
      data,
    );
  }

  public search(
    organisationId: string,
    params?: TemplateSearchParams,
  ): Observable<APIResponse<Template[]>> {
    return this.api.get<APIResponse<Template[]>>(
      queryParamString(`organisations/${organisationId}/templates`, params),
    );
  }

  public update(
    organisationId: string,
    templateId: string,
    data: TemplateUpdate,
  ): Observable<Template> {
    return this.api.put<Template, TemplateUpdate>(
      `organisations/${organisationId}/templates/${templateId}`,
      data,
    );
  }

  public delete(
    organisationId: string,
    templateId: string,
  ): Observable<Template> {
    return this.api.delete(
      `organisations/${organisationId}/templates/${templateId}`,
    );
  }

  public createJob(organisationId: string, templateId: string): Observable<Job> {
    return this.api.post(
      `organisations/${organisationId}/templates/${templateId}/createOrder`,
      {}
    );
  }

  public duplicate(
    organisationId: string,
    templateId: string,
  ): Observable<Template> {
    return this.api.post(
      `organisations/${organisationId}/templates/${templateId}/duplicate`,
      {}
    );
  }
}
